import type { Me } from '@libs/types';

const DEV_ENV = import.meta.env.VITE_ENV;

// For dev
import { meData } from '@hooks/stub-data-dev.ts';

type ApiMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

interface ApiRequestOptions {
  method: ApiMethod;
  endpoint: string;
  data?: FormData | null;
  headers?: Record<string, string>;
}

const BASE_URL = '/api/auth';

const apiRequest = async <T>(params: ApiRequestOptions): Promise<T> => {
  const { method, endpoint, data, headers = {} } = params;

  const options: RequestInit = {
    method,
    // headers: {
    //   'Content-Type': 'application/json',
    //   ...headers,
    // },
    headers,
    // body: data ? JSON.stringify(data) : undefined,
    body: data,
  };

  const url = `${BASE_URL}/${endpoint}`;

  const response = await fetch(url, options);

  // if (response.status === 401) {
  //   handleUnauthorizedError();
  // }

  if (!response.ok) {
    const errorData = await response.json();

    throw new Error(
      errorData.message || errorData.detail || 'Something went wrong',
    );
  }

  return response.json() as Promise<T>;
};

export const getMe = async (): Promise<Me> => {
  if (DEV_ENV === 'development') {
    return new Promise((resolve) => resolve(meData));
  }

  return apiRequest<Me>({ method: 'GET', endpoint: 'me' });
};
